// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const getSerialNumberHeader = showPartInvoiceNumber =>
    showPartInvoiceNumber ? 'SERIAL_NUMBER_INVOICE_NUMBER' : 'SERIAL_NUMBER';

const PartsPanelRowHeader = props =>
    <section className='parts-panel-row-header'>
        <span
            className={'quantity'}
        >
            <FormattedMessage id={'QUANTITY'}/>
        </span>
        <span
            className={'part-number'}
        >
            <FormattedMessage id={'PART_NUMBER'}/>
        </span>
        <span
            className={'description'}
        >
            <FormattedMessage id={'DESCRIPTION'}/>
        </span>
        <span
            className={'unit'}
        >
            <FormattedMessage id={'UNIT'}/>
        </span>
        <span
            className={'serial-number'}
        >
            <FormattedMessage id={getSerialNumberHeader(props.showPartInvoiceNumber)}/>
        </span>
    </section>;

PartsPanelRowHeader.displayName = 'PartsPanelRowHeader';

PartsPanelRowHeader.propTypes = {
    showPartInvoiceNumber: PropTypes.bool.isRequired
};

export default PartsPanelRowHeader;



// WEBPACK FOOTER //
// ./src/claim/shared/components/parts-panel/parts-panel-row-header.js